import CONFIG from '@/constants/config.js';
import Utils from "../store/modules/base";
export var solutionMixin = {
    data: () => ({

    }),
    computed: {
        solutions() {
            return this.spot && this.spot.raetsel ? this.spot.raetsel.lsg : [];
        },
        hasUserInput() {
            return this.spot && this.spotAlreadyTouched(this.spot) && this.spot.raetsel && (!this._.isEmpty(this.spot.raetsel.user_input) || !this._.isEmpty(this.spot.raetsel.user_input_json))
        },
        userInput() {
            return (this.spot && this.spot.raetsel) ? this.spot.raetsel.user_input : [];
        }
    },
    methods: {
        formatDateTime(date = new Date) {
            return date.toISOString().
            replace(/T/, ' '). // replace T with a space
            replace(/\..+/, '')
        },
        getSpotTitle(item) {
            let title = '';
            if (!this.isSecretSpot(item)) {
                title = item ? (item.raetsel ? item.raetsel.raname : item.wphead) : '';
                // keywordExtras comes from eventMixin; components without it get the reduced context
                title = Utils.replaceKeywords(title, this.getOfflineStatistic, this.allSpots, this.keywordExtras)
            }
            return title;
        },
        spotIsCheckedIn(spot) {
            return spot && spot.checkin_time != null && this._.isString(spot.checkin_time);
        },
        spotIsSolved(spot) {
            return spot && (spot.tstatus == CONFIG.SPOT_STATE_SOLVED && spot.checkout_time != null && this._.isString(spot.checkout_time)) || (this.isInfoSpot(spot) && this.spotIsCheckedIn(spot));
        },
        spotIsFailed(spot) {
            return spot && spot.tstatus == CONFIG.SPOT_STATE_FAILED && spot.checkout_time != null && this._.isString(spot.checkout_time);
        },
        spotAlreadyTouched(spot) {
            return (this.spotIsSolved(spot) || this.spotIsFailed(spot));
        },
        spotIsActive(spot) {
            return spot && spot.tstatus == CONFIG.SPOT_STATE_ACTIVE;
        },
        spotIsInactive(spot) {
            return spot && spot.tstatus == CONFIG.SPOT_STATE_INACTIVE;
        },

        spotHasDescription(spot) {
            return (!spot.raetsel && !this._.isEmpty(spot.wptxt)) || (spot.raetsel && !this._.isEmpty(spot.raetsel.radescr))
        },

        spotMustBeInRange(spot, eventSettingsGpsDisabled){
            return spot && spot.indoor === CONFIG.CHECKIN_GPS && !eventSettingsGpsDisabled;
        },

        spotIsInRange(spot){
            return (spot.distanceToCurrentPosition || spot.distanceToCurrentPosition===0) && spot.distanceToCurrentPosition*1000<=spot.scr;
        },

        spotHasAnswerTimeLimit(spot){
            return (spot && spot.answer_time_limit && !this.spotAlreadyTouched(spot))?true:false;
          },
                    
        hasTrialsLeft(spot) {
            return spot && spot.trials;
        },
        isTaskSpot(item) {
            return (item && item.raetsel);
        },
        isInfoSpot(item) {
            return !this.isTaskSpot(item);
        },
        isSecretSpot(spot) {
            return spot && spot.typ == CONFIG.SPOT_IMG_TYPE_SECRET;
        },
        isVotingSpot(item) {
            return (item && item.raetsel && item.raetsel.voting_type_id != null);
        },
        isCheckinTypePasswort(item) {
            let res = false;
            if (item) {
                let checkinType = item.indoor;
                res = (checkinType == CONFIG.CHECKIN_PASSWORD);
            }
            return res;
        },

        isCheckinTypeQr(item) {
            let res = false;
            if (item) {
                let checkinType = item.indoor;
                res = (checkinType == CONFIG.CHECKIN_QR);
            }
            return res;
        },
        isSolutionTypeText(item) {
            return this.isTaskSpot(item) && (item.raetsel.ralsgtyp == CONFIG.SOLUTION_TYPE_TEXT_ID)
        },
        isSolutionTypeTextQr(item) {
            return this.isTaskSpot(item) && (item.raetsel.ralsgtyp == CONFIG.SOLUTION_TYPE_QR_ID)
        },
        isSolutionTypeTextOpen(item) {
            return this.isTaskSpot(item) && (item.raetsel.ralsgtyp == CONFIG.SOLUTION_TYPE_OPEN_ID)
        },
        isSolutionTypeMc(item) {
            return this.isTaskSpot(item) && (item.raetsel.ralsgtyp == CONFIG.SOLUTION_TYPE_MC_ID)
        },
        isSolutionTypeMcOpen(item) {
            return this.isTaskSpot(item) && (item.raetsel.ralsgtyp == CONFIG.SOLUTION_TYPE_OPEN_MC_ID)
        },
        isSolutionTypePhoto(item) {
            return this.isTaskSpot(item) && (item.raetsel.ralsgtyp == CONFIG.SOLUTION_TYPE_FOTO_ID)
        },
        isSolutionTypeVideo(item) {
            return this.isTaskSpot(item) && (item.raetsel.ralsgtyp == CONFIG.SOLUTION_TYPE_VIDEO_ID)
        },
        isSolutionTypeJsTask(item) {
            return this.isTaskSpot(item) && (item.raetsel.ralsgtyp == CONFIG.SOLUTION_TYPE_JS_TASK_ID)
        },
        isSolutionTypeAr(item) {
            return this.isTaskSpot(item) && (item.raetsel.ralsgtyp == CONFIG.SOLUTION_TYPE_AR_ID)
        },
        isSolutionTypeVoting(item) {
            return this.isTaskSpot(item) && (item.raetsel.ralsgtyp == CONFIG.SOLUTION_TYPE_VOTING_ID)
        },
        isSolutionSubType(item, subType) {
            return item.raetsel.voting_type_id == subType;
        },
        getServerData(userAnswer, isFile = false, item = null) {

            let params = this.getParams(userAnswer, item)
            params['input_json'] = this.getJsonInput(userAnswer, item);
            if (isFile) {
                params['filename'] = userAnswer;
            }

            return params;
        },
        getParams(userAnswer, item = null) {
            let params = {
                lsgwortCount: 0,
                lsgwort: ""
            };

            if (item && this.isSolutionTypeJsTask(item)) {
                // Exception for JS tasks
                if (!this._.isEmpty(userAnswer)) {
                    params.lsgwortCount = 1;
                    const jsAnswer = JSON.parse(userAnswer);
                    params.lsgwort = JSON.stringify(jsAnswer.userInput);
                    // params.lsgwort = jsAnswer.userInput.toString();
                    // console.log("params.lsgwort", params.lsgwort)
                }
            }
            else{

                userAnswer = (!this._.isArray(userAnswer)) ? [userAnswer] : userAnswer;
                if (!this._.isEmpty(userAnswer)) {
                    params.lsgwortCount = userAnswer.length;

                    for (const [i, v] of userAnswer.entries()) {
                        let lsg = (i == 0) ? `lsgwort` : `lsgwort_${i+1}`
                        params[lsg] = v;
                    }
                }
            }

            return params;
        },
        getJsonInput(userAnswer, item = null) {
            // console.log("getJsonInput()");

            if (item && this.isSolutionTypeJsTask(item)) {
                // For JS tasks, the answer is already a json string
                return JSON.parse(userAnswer);
            }

            let user_input = {};
            userAnswer = (!this._.isArray(userAnswer)) ? [userAnswer] : userAnswer;
            userAnswer.forEach((data) => {
                let str = data;
                if (this._.isString(str)) {
                    // probably not needed to escape characters for webapp
                    // if (str.indexOf("\"") > -1) {
                    //     str = str.replaceAll("\"", "\\\"")
                    // }
                    user_input[`${str}`] = true;
                }
            });

            //if we have a voting solution we need to do some extra computation here 
            // to acchive the desired format { Label1: value1, Label2: value2 .... }
            if (item && this.isSolutionTypeVoting(item)) {
                // console.log("getJsonInput() IF");
                //voting type stars
                if (item.raetsel.voting_type_id == CONFIG.VOTING_TYPE_STARS) {
                    let newUserInput = {};
                    let result = null;
                    Object.keys(user_input).forEach(element => {
                        const regex = /(^.+)\((\d+)\/(\d+)\)/g;
                        result = regex.exec(element);
                        if (result && result[1] && result[2]) {
                            newUserInput[result[1]] = parseInt(result[2]);
                        }
                    })
                    user_input = newUserInput;
                } else if (item.raetsel.voting_type_id == CONFIG.VOTING_TYPE_THUMBS || item.raetsel.voting_type_id == CONFIG.VOTING_TYPE_SMILEYS) {
                    // console.log("getJsonInput() ELSE");
                    let newUserInput = {};
                    let result = null;
                    Object.keys(user_input).forEach(element => {
                        let regex = /(^.+)\((-?\d+)\)/g;
                        result = regex.exec(element);
                        if (result && result[1] && result[2]) {
                            newUserInput[result[1]] = parseInt(result[2]);
                        }
                    })
                    user_input = newUserInput;
                }
            }

            return user_input;
        },
    }
}